export default __webpack_public_path__ + "static/media/close.9e45d718.svg";